import repository from '@/modules/machinery/services/machineriesRepository';
import notificationService from '@/services/notificationService';

export default class Machinery implements IMachinery {
    public id: string = '';
    public active: boolean = true;
    public supplierId: string = '';
    public licensePlate: string = '';
    public internalNumber: string = '';
    public brand: string = '';
    public type: string = '';
    public purchaseDate: string | null = null;
    public profileId: string = '';
    public serialNumber: string = '';
    public purchaseValue: number | null = null;
    public residualValue: number | null = null;
    public listPrice: number | null = null;
    public color: string = '';
    public constructionYear: number | null = null;
    public customProperties: any;

    public saving: boolean = false;
    public loading: boolean = false;
    public dirty: boolean = false;

    public async init(id: string) {
        try {
            this.loading = true;
            const result = await repository.getSingle(id);

            Object.assign(this, result.data);
        } catch (err) {
            notificationService.failedToLoad();
        } finally {
            this.loading = false;
        }
    }

    public async save() {
        try {
            this.saving = true;
            const result = this.id ? await repository.update(this) : await repository.create(this);
            if (!this.id) {
                Object.assign(this, result.data);
            }
            this.dirty = false;
            notificationService.saved();
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.saving = false;
        }
    }

    public async delete() {
        try {
            this.saving = true;
            await repository.delete(this.id);
            return true;
        } catch (err) {
            notificationService.showAxiosError(err);
            this.saving = false;
            return false;
        }
    }
}
